import { useEffect, useState } from 'react';
import { getEmitter } from '@laigu/utils';

import { getData } from '../store';

const emitter = getEmitter();

// 配置项数据
function useConfig() {
  const [config, setConfig] = useState(getData());

  const handleGetConfig = config => {
    setConfig(oldVal => ({ ...oldVal, ...config }));
  };

  useEffect(() => {
    emitter.on('setEditorConfig', handleGetConfig);
  }, []);
  return config;
}

export default useConfig;
